const MINIMUM_PRELOAD_DISTANCE = 80;

const finiteNumber = (value, fallback) => {
  const resolved = Number(value);
  return Number.isFinite(resolved) ? resolved : fallback;
};

export const shouldPreloadOlderHistory = ({
  scrollTop,
  viewportHeight,
  hasOlder,
  loadingOlder,
} = {}) => {
  const distanceToBoundary = Math.max(0, finiteNumber(scrollTop, Number.POSITIVE_INFINITY));
  const preloadDistance = Math.max(
    MINIMUM_PRELOAD_DISTANCE,
    Math.max(0, finiteNumber(viewportHeight, 0)),
  );
  return [
    hasOlder === true,
    loadingOlder !== true,
    distanceToBoundary <= preloadDistance,
  ].every(Boolean);
};
